<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
};
</script>

<style>
body {
    margin: 0;
    padding: 0;
    background-color: rgb(255, 255, 255);
    //overflow: hidden;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    //overflow: hidden;
}

/* 滚轮 */
::-webkit-scrollbar-track-piece {
    background-color: #f8f8f8;
}

::-webkit-scrollbar {
    width: 0;
    height: 0;
}

::-webkit-scrollbar-thumb {
    background-color: rgb(187, 222, 251);
    background-clip: padding-box;
    min-height: 28px;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
}

a {
    color: rgb(24, 160, 158);
    text-decoration: none;
}

.fade-in-element {
    opacity: 0;
    transition: opacity 1s ease-in-out;
}

.fade-in {
    opacity: 1;
}

.el-loading-spinner {
    /*这个是自己想设置的 gif 加载动图*/
    background-image: url('https://store.ptcc9.top/notmaker/images/loading2.svg');
    background-repeat: no-repeat;
    background-size: 60px 50px;
    height: 50px;
    width: 100%;
    background-position: center;
    /*覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了*/
    top: 40%;
}

.el-loading-spinner .circular {
    /*隐藏 之前  element-ui  默认的 loading 动画*/
    display: none;
}

.el-loading-spinner .el-loading-text {
    /*为了让文字在loading图下面*/
    margin: 106px 0px;
    color: #da70a0;
}

.global_front_mini {
    font-size: 11px;
}

.el-message-box {
    width: 400px !important;
}

@media (max-width: 1140px) {
    .el-message-box {
        width: 95vw !important;
    }
}
</style>
